import controller from './taxation.controller';
import template from './taxation.html';

const taxationComponent = {
  restrict: 'E',
  bindings: {},
  controller,
  template
};

export default taxationComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/taxation/taxation.component.js
 **/